import PropTypes from 'prop-types';

function MMBeveragesInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11308)">
                <path
                    d="M2.87759 5.34114L2.53448 2.94419L13.1897 1.69092L13.6662 3.80671L2.87759 5.34114Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.87766 5.3457C2.87766 5.3457 1.74828 8.91491 1.82929 10.4112C1.9103 11.9075 4.33107 28.0095 4.38826 28.3955C4.44544 28.7814 8.13855 29.8918 8.13855 29.8918C8.13855 29.8918 7.22361 14.1091 5.61294 9.27708C5.22219 8.09528 2.87766 5.3457 2.87766 5.3457Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.87762 5.34549C2.87762 5.34549 4.92194 8.20467 5.26027 9.7248C5.59861 11.2449 7.74299 29.944 8.11945 29.8915C8.49591 29.8391 19.0368 26.9371 19.0796 26.6845C19.1225 26.4319 16.8114 9.32451 16.5159 8.64308C16.2205 7.96164 13.8569 3.77771 13.6567 3.8063L2.87762 5.34549Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.89069 22.5521L9.89015 22.5522C9.78785 22.575 9.68194 22.5764 9.57907 22.5564C9.4762 22.5363 9.3786 22.4951 9.29239 22.4355C9.20618 22.3759 9.13323 22.2991 9.07811 22.21C9.02301 22.1209 8.98692 22.0213 8.97212 21.9176C8.97212 21.9175 8.97212 21.9175 8.97212 21.9175L8.39593 17.8556C8.37415 17.6701 8.42148 17.4829 8.52893 17.33C8.6368 17.1765 8.79761 17.0682 8.98045 17.0262C8.98055 17.0261 8.98065 17.0261 8.98075 17.0261L15.0701 15.6443L15.0708 15.6442C15.1748 15.6203 15.2827 15.6187 15.3874 15.6395C15.492 15.6604 15.5911 15.7032 15.678 15.7651C15.765 15.827 15.8378 15.9066 15.8917 15.9987C15.9457 16.0908 15.9795 16.1933 15.9909 16.2994L15.9909 16.2994L15.9912 16.3014L16.4676 20.4037C16.4676 20.4039 16.4677 20.404 16.4677 20.4041C16.4888 20.5908 16.4401 20.7787 16.3309 20.9316C16.2216 21.0846 16.0595 21.1916 15.8759 21.2321L15.8759 21.2321L9.89069 22.5521Z"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                />
                <path
                    d="M22.0134 21.5475L25.2657 21.3006C26.5274 21.1971 27.7399 20.7641 28.7817 20.0449C29.7569 19.3877 30.0081 17.5628 29.9579 16.2778C29.9705 15.7333 29.8708 15.1921 29.6648 14.688C29.4588 14.1838 29.151 13.7276 28.7607 13.3478C27.7939 12.406 26.8772 12.3181 25.8852 12.1507C24.8932 11.9833 21.2809 12.3558 21.2809 12.3558L21.4567 14.051C22.0846 13.9715 25.0648 13.3855 26.5716 13.9547C28.0785 14.524 28.4594 15.3946 28.292 17.3033C28.1622 18.7766 26.4 19.35 25.136 19.4463L21.8962 19.6975L22.0134 21.5475Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.679 9.36719C22.679 9.36719 23.2315 14.0593 23.3613 15.7587C23.491 17.4581 23.5957 19.4965 23.6166 20.363C23.6166 21.0494 23.9766 23.1632 23.7589 23.5231C23.5412 23.8831 21.7958 25.2811 17.359 25.3774C12.9222 25.4737 11.7837 25.1681 11.5367 24.5026C11.2898 23.8371 11.2186 20.3169 10.98 17.2279L10.4526 10.3006L22.679 9.36719Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.761 10.8551C20.1476 10.5842 22.8546 9.88484 22.8073 9.29305C22.7599 8.70126 19.9762 8.44115 16.5895 8.71208C13.2029 8.983 10.4959 9.68238 10.5432 10.2742C10.5906 10.866 13.3744 11.1261 16.761 10.8551Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.4324 10.899C11.792 10.6269 14.8852 10.0619 15.9107 9.98652C16.9362 9.91118 18.8742 9.72701 19.5774 9.88606C20.0252 9.99775 20.4656 10.1376 20.8959 10.3046C20.1078 10.5054 19.3083 10.6578 18.5016 10.7609C17.7608 10.7944 13.1524 11.2087 12.4324 10.899Z"
                    fill="#2D2D2D"
                />
                <path
                    d="M17.8679 6.15326C18.0829 5.94417 18.2225 5.66972 18.2649 5.37284C18.3073 5.07596 18.2501 4.77339 18.1023 4.51247C17.8107 4.05226 17.5746 3.55909 17.3991 3.0433C17.3778 2.58727 17.527 2.13964 17.8177 1.7876"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.4377 6.03191C19.6551 5.75078 19.7896 5.4144 19.8258 5.06082C19.8621 4.70724 19.7987 4.35057 19.6428 4.03116C19.3389 3.45777 19.0949 2.85465 18.9144 2.23132C18.8691 1.68622 19.006 1.1415 19.3037 0.682617"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11308">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.287109)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMBeveragesInactive;

MMBeveragesInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMBeveragesInactive.defaultProps = {
    className: null,
};
